<div class="member-search-header">
  <h2>Search Member </h2>
  <a class="close-button" (click)="closeForm('')">
    <i class="fa fa-times"></i>
  </a>
</div>
<div class="member-search-container">
  <form [formGroup]="form">
    <div class="ui-fluid">
      <div class="ui-g-12 ui-md-12 ui-lg-12 padding-top-0 padding-bottom-0">
        <div class="ui-g-3">
          <form-factory [formGroup]="form" [model]="memberIdInput"></form-factory>
        </div>
        <div class="ui-g-3">
          <form-factory [formGroup]="form" [model]="memberFirstNameInput"></form-factory>
        </div>
        <div class="ui-g-3">
          <form-factory [formGroup]="form" [model]="memberLastNameInput"></form-factory>
        </div>
        <div class="ui-g-3">
          <form-factory [formGroup]="form" [model]="memberDateOfBirthInput"></form-factory>
        </div>

      </div>
    </div>

    <div class="ui-fluid">
      <div class="ui-g-12 ui-md-12 ui-lg-12 padding-top-0">
        <div class="ui-g-12 text-right padding-bottom-0 search-button">
          <app-button class="button margin-right-10" (onClick)="search()" [disabled]="!validateFilterForm()"
            text="Search"></app-button>

          <app-button class="button" (onClick)="clearControls()" type="button" text="Clear"></app-button>
        </div>
      </div>
    </div>
  </form>

  <div class="ui-fluid">
    <div class="ui-g-12 ui-md-12 ui-lg-12 padding-top-0">
      <h3 class="margin-top-0">RESULTS</h3>
      <div class="filter-grid">
        <app-basic-grid [(selection)]="selectedMember" [configuration]="gridConfigurationModel" [data]="memberData" [request]="request"
          [refreshViews]="refreshViews" [urlOptions]="searchRequest">
        </app-basic-grid>
      </div>
    </div>
  </div>
  <footer class="text-right">
    <app-button class="usebutton"
                (onClick)="selectAndClose()"
                text="USE THIS MEMBER"></app-button>
  </footer>
</div>